import { IModifyConsumptionRepository } from '@modules/modify-consumption/domain'
import { solarSalesAxios } from '@infrastructure/apiService'

const mapToApiParams = ({
  previousAnnualConsumption,
  newConsumptions,
  reason,
}: {
  previousAnnualConsumption: number
  newConsumptions: []
  reason: string
}) => ({
  previous_annual_consumption: previousAnnualConsumption,
  new_annual_consumption: newConsumptions,
  reason,
})

export const modifyConsumptionService: IModifyConsumptionRepository = {
  modifyConsumption: async ({
    cups,
    previousAnnualConsumption,
    newConsumptions,
    reason,
  }) => {
    const requestData = mapToApiParams({
      previousAnnualConsumption,
      newConsumptions,
      reason,
    })

    const { data } = await solarSalesAxios.put(
      `/${cups}/consumption`,
      requestData
    )

    return data
  },
}
